import { FlotiMapState } from "./types"
import { FlotiMapAction } from "./actions"
import { MAP_TYPE_IDS } from "../data"
import { Action } from "../../../contexts/types"

export const PROJECTION_TYPE = 'EPSG:4326'
export const CENTER_ICELAND_COORDS = [ -2141435.1100608245, 9593858.305547735 ]
export const DEFAULT_MAP_ZOOM = 7

const initial_flotiMap: FlotiMapState = {
  map: undefined,
  points: undefined,
  icons: undefined,
  polygons: undefined,
  circles: undefined,
  tile: MAP_TYPE_IDS.OPEN_STREETMAP,
  viewOptions: {
    roadConditions: false,
    weather: false,
    liveCams: false,
    clusterMarkers: false,
    clusterIcons: false,
  }
}

const flotiMapReducer = (state = initial_flotiMap, action: Action): FlotiMapState => {
  const { data, type } = action ?? {}
  switch (type) {
    case FlotiMapAction.SET_INITIAL_MAP:
      return {
        ...initial_flotiMap,
        map: data
      }
      break

    case FlotiMapAction.SET_INITIAL_OPTIONS:
      return {
        ...state,
        tile: data.tile,
        viewOptions: {
          ...state.viewOptions,
          ...data.viewOptions,
        }
      }

    case FlotiMapAction.SET_MAP_POINTS:
      return {
        ...state,
        points: data
      }
      break
    
    case FlotiMapAction.SET_POLYSHAPES:
      return {
        ...state,
        polygons: data
      }
      break

    case FlotiMapAction.SET_CIRCLES:
      return {
        ...state,
        circles: data
      }
      break

    case FlotiMapAction.SET_TILE:
      return {
        ...state,
        tile: data
      }
      break
    
    case FlotiMapAction.SET_VIEW_OPTIONS:
      return {
        ...state,
        viewOptions: {
          ...state.viewOptions,
          ...data
        }
      }
      break

    case FlotiMapAction.SET_MAP_ICONS:
      return {
        ...state,
        icons: data
      }
      break
      
    default:
      return state
  }
}

export { flotiMapReducer, initial_flotiMap }
